module.exports = __webpack_public_path__ + "img/mini-017.d6e0e844.jpg";